import { ReactNode } from "react";

export const ExamPageTypeContainer = ({
  title,
  children,
  actions,
  isH1 = false,
}: {
  title: string;
  children: ReactNode;
  actions?: ReactNode;
  isH1?: boolean;
}) => {
  const Heading = ({ children }: { children: ReactNode }) => {
    const headingStyles = "text-card-foreground text-base font-semibold";
    return isH1 ? (
      <h1 className={headingStyles}>{children}</h1>
    ) : (
      <div className={headingStyles}>{children}</div>
    );
  };
  return (
    <div className={"my-6 rounded-xl border p-4 md:p-8"}>
      <header
        className={
          "mb-8 flex flex-col justify-between gap-4 sm:flex-row sm:items-center"
        }
      >
        <Heading>{title}</Heading>
        <div>{actions}</div>
      </header>
      <div className={"flex flex-col gap-4"}>{children}</div>
    </div>
  );
};
